// Route path constants - change these to update all routes
export const ROUTES = {
  ACCOUNTS: '/accounts',      // Previously /clients
  OPERATIONS: '/operations',  // Previously /internal
  STAFF: '/staff'
};

// Display names for tabs
export const TAB_LABELS = {
  // Short, scannable section names (breadcrumbs/sidebar)
  ACCOUNTS: 'Accounts',
  OPERATIONS: 'Operations',
  STAFF: 'Staff'
};

// Special client ID for internal items without a client
export const INTERNAL_CLIENT_ID = 'internal';

